<template>
	<CRow class="ml-0 mr-0">
		<img
			class="thumbnail-54"
			data-test-id="thumbnail"
			:src="thumbnail"
		>
		<CCol class="flex-grow-1 d-flex flex-column justify-content-center">
			<div class="d-flex badge-list mb-2">
				<div :class="['badge', { '-freebie' : isFreebie, '-itec' : isItec}]">
					{{ badgeText }}
				</div>
				<div v-if="isStackable" class="badge -stackable">
					Combine with other discount
				</div>
			</div>
			<div class="typo-body-2 text-left" data-test-id="name">
				{{ name }}
			</div>
			<div v-if="description" class="typo-caption color-black-45 mb-2">
				{{ description }}
			</div>
		</CCol>
		<CButton
			class="btn-delete-item"
			@click="$emit('onEdit')"
		>
			<CIcon name="cil-pencil" />
		</CButton>
		<CButton
			class="btn-delete-item"
			@click="$emit('onRemove')"
		>
			<CIcon name="cil-trash" />
		</CButton>
	</CRow>
</template>

<script>

import {
	DAPP_REWARD_TYPE,
	DISCOUNT_TYPE_DAPP_KEYS,
} from '../enums/promotions';

import { numberFormat } from '../assets/js/helpers';

export default {
	name: 'PromotionDappRewardItem',

	props: {
		thumbnail: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		discountType: {
			type: String,
			default: '',
		},
		discount: {
			type: String,
			default: '',
		},
		isStackable: {
			type: Boolean,
			default: false,
		},
	},

	computed: {
		isFreebie() {
			return this.type === DAPP_REWARD_TYPE.FREEBIE;
		},
		isItec() {
			return this.type === DAPP_REWARD_TYPE.ITEC;
		},
		badgeText() {
			switch (this.type) {
				case DAPP_REWARD_TYPE.FREEBIE:
					return 'Freebie';
				case DAPP_REWARD_TYPE.DISCOUNT:
					if (this.discountType === DISCOUNT_TYPE_DAPP_KEYS.DAPP_PERCENTAGE_DISCOUNT) {
						return `Discount ${numberFormat(this.discount || 0)}%`;
					}
					return `Discount ฿${numberFormat(this.discount || 0)}`;
				case DAPP_REWARD_TYPE.ITEC:
					return 'ITEC (Min. Price)';
				default: return 'null';
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.badge-list {
	gap: 8px;
}

.badge {
	font-size: 8px;
	font-weight: 600;
	background-color: #ffe0cd;

	padding: 4px 8px;
	border-radius: 4px;

	align-self: flex-start;

	&.-freebie {
		background-color: #d4e9ff;
	}

	&.-itec {
		background-color: #e6e6ff;
	}

	&.-stackable {
		background-color: #ffbfbf;
	}
}
</style>
